import { BrandKey } from '@prismamedia/one-brandkey';
import { OneMedia } from '@prismamedia/one-components';
import {
  GetCampaignsBlocksQuery_blocks_Block_section_Section_campaign_Campaign,
  Media,
} from '__generated__/queries-newsletter';
import { RecipeStatus } from '__generated__/queries-recipe';
import { ArticleFormat, ArticleStatus } from '__generated__/queries-web';
import { EditorState } from 'draft-js';
import { formatDate } from 'utils/dateUtils';

export interface BlockItemType {
  articleAuthors?: any[];
  articleCategories?: any[];
  articleChannels?: any[];
  articleCreatorData?: { name?: string | null } | null;
  articleEvents?: any[];
  articleQualifiers?: any[];
  blockType?: string | null;
  brandKey?: BrandKey | string;
  campaigns?: GetCampaignsBlocksQuery_blocks_Block_section_Section_campaign_Campaign[];
  content?: string | EditorState | null;
  editedAt?: string | null;
  format?: ArticleFormat;
  id: string;
  isAutoPromo?: boolean | null;
  leadIn?: boolean | null;
  linkLabel?: string | EditorState | null;
  liveCount?: number;
  media?: OneMedia | Media | null;
  mediaForDisplay?: string | null;
  medias?: OneMedia[] | null;
  body?: string | null;
  pushCount?: number;
  publishedAt?: string | null;
  status?: ArticleStatus | RecipeStatus | null;
  surTitle?: string | EditorState | null;
  title?: string | EditorState | null;
  url?: string | null;
  urlInError?: boolean;
  urlInErrorMessage?: string;
}

export function isOneMedia(media?: OneMedia | Media | null): media is OneMedia {
  return (
    media !== null &&
    media !== undefined &&
    (media as OneMedia).iframely &&
    (media as OneMedia).iframely.meta !== undefined
  );
}

export const getAlreadyUsedText = (
  campaigns?: GetCampaignsBlocksQuery_blocks_Block_section_Section_campaign_Campaign[],
) => {
  if (!campaigns?.length) {
    return '';
  }
  // const [{ newsletter, availableAt }] = campaigns;
  // return `Déjà utilisé : ${newsletter!.name} le ${formatDate(
  //   new Date(availableAt!),
  //   'dd/MM/yyyy',
  // )}`;
  return campaigns
    ?.map(
      ({ newsletter, availableAt }) =>
        `Déjà utilisé : ${newsletter?.name} le ${formatDate(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          new Date(availableAt!),
          'dd/MM/yyyy',
        )}`,
    )
    .join('\n');
};
